export default __webpack_public_path__ + "static/media/avatar_brown_bear5.594e64ef.mp3";